import {Component, ElementRef, Input, OnInit, TemplateRef, ViewChild} from "@angular/core";
import {FormService} from "../../services/form.service";
import {FormGroup} from "@angular/forms";
import {NbDialogService, NbPopoverDirective} from "@nebular/theme";
import {isMobile} from "../../../app.component";
import {Observable} from "rxjs";
import {StandaloneFormService} from "../../services/standalone-form.service";

@Component({
    selector: 'text-area',
    templateUrl: './text-area.template.html',
    styleUrls: ['./text-area.style.scss'],
    standalone: false
})
export class TextAreaComponent implements OnInit {

	@Input() label: string;
	@Input() htmlPrefix: string;
	@Input() placeholder: string;
	@Input() autoGrowEnabled: boolean;
	@Input() controlName: string;
	@Input() formService: FormService;
	@Input() formKey?: string = StandaloneFormService.FORM_KEY;
	@Input() description: string = null;
	@Input() dataTestId: string

	@ViewChild(NbPopoverDirective, {static: false}) popover: NbPopoverDirective;
	@ViewChild('textAreaElement', {static: true}) textAreaElement: ElementRef<HTMLTextAreaElement>;

	@Input() form: FormGroup;

	private isStandaloneFormComponent: boolean;

	constructor(private dialogService: NbDialogService) {
	}

	ngOnInit(): void {
		this.isStandaloneFormComponent = this.formKey == StandaloneFormService.FORM_KEY;
	}

	autoGrow() {
		if (this.textAreaElement.nativeElement.scrollHeight > this.textAreaElement.nativeElement.clientHeight) {
			this.textAreaElement.nativeElement.style.height = this.textAreaElement.nativeElement.scrollHeight + 'px';
		}
	}

	isInvalid(): boolean {
		return this.formService.isInvalid(this.formKey, this.controlName);
	}

	getValidationErrors(): Observable<string> {
		return this.formService.getErrorsString(this.formKey, this.controlName);
	}

	showExplanationDialog(dialog: TemplateRef<any>) {
		this.dialogService.open(dialog);
	}

	isMobile(): boolean {
		return isMobile == true;
	}

	htmlId(): string {
		return `${this.htmlPrefix}-${this.formKey ? this.formKey.toLowerCase() : ''}`;
	}

	fullControlName(): string {
		if (!!this.formKey && !this.isStandaloneFormComponent) {
			return this.controlName.endsWith(this.formKey) ? this.controlName : this.controlName + this.formKey;
		}

		return this.controlName;
	}

}
